// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__vFMnl","paddedCard":"styles_paddedCard__3SP8X"};